module.exports = __webpack_public_path__ + "static/media/parceiro(6).a4e15ecb.png";